export default __webpack_public_path__ + "static/media/factory__41.36adce85.jpg";